"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var middles_1 = require("topology-core/middles");

var data_1 = require("./data");

var subprocess_1 = require("./subprocess");

var db_1 = require("./db");

var document_1 = require("./document");

var internalStorage_1 = require("./internalStorage");

var externStorage_1 = require("./externStorage");

var queue_1 = require("./queue");

var manually_1 = require("./manually");

var display_1 = require("./display");

var parallel_1 = require("./parallel");

var comment_1 = require("./comment");

function register() {
  middles_1.registerNode('flowData', data_1.flowData, data_1.flowDataAnchors, data_1.flowDataIconRect, data_1.flowDataTextRect);
  middles_1.registerNode('flowSubprocess', subprocess_1.flowSubprocess, null, subprocess_1.flowSubprocessIconRect, subprocess_1.flowSubprocessTextRect);
  middles_1.registerNode('flowDb', db_1.flowDb, null, db_1.flowDbIconRect, db_1.flowDbTextRect);
  middles_1.registerNode('flowDocument', document_1.flowDocument, document_1.flowDocumentAnchors, document_1.flowDocumentIconRect, document_1.flowDocumentTextRect);
  middles_1.registerNode('flowInternalStorage', internalStorage_1.flowInternalStorage, null, internalStorage_1.flowInternalStorageIconRect, internalStorage_1.flowInternalStorageTextRect);
  middles_1.registerNode('flowExternStorage', externStorage_1.flowExternStorage, externStorage_1.flowExternStorageAnchors, externStorage_1.flowExternStorageIconRect, externStorage_1.flowExternStorageTextRect);
  middles_1.registerNode('flowQueue', queue_1.flowQueue, null, queue_1.flowQueueIconRect, queue_1.flowQueueTextRect);
  middles_1.registerNode('flowManually', manually_1.flowManually, manually_1.flowManuallyAnchors, manually_1.flowManuallyIconRect, manually_1.flowManuallyTextRect);
  middles_1.registerNode('flowDisplay', display_1.flowDisplay, display_1.flowDisplayAnchors, display_1.flowDisplayIconRect, display_1.flowDisplayTextRect);
  middles_1.registerNode('flowParallel', parallel_1.flowParallel, parallel_1.flowParallelAnchors, null, null);
  middles_1.registerNode('flowComment', comment_1.flowComment, comment_1.flowCommentAnchors, null, null);
}

exports.register = register;